import { useEffect, useState } from 'react';
import { StyledEnvironmentWall } from './EnvironmentWall.styled';
import { Input } from 'antd';
import Button from '../Button/Button';
import { notification } from 'antd';

export default function EnvironmentWall() {
  const [showWall, setShowWall] = useState(false);
  const [value, setValue] = useState('');
  const environment = process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT;

  useEffect(() => {
    if (environment == 'staging') {
      setShowWall(true);
    } else {
      setShowWall(false);
    }
  }, [environment]);

  useEffect(() => {
    if (localStorage.getItem('environment-wall')) {
      setShowWall(false);
    }
  }, []);

  const onSubmit = () => {
    if (value?.includes('@rockalingua.com')) {
      localStorage.setItem('environment-wall', 'passed');
      setShowWall(false);
    } else {
      setValue('');
      notification.error({
        message: 'Error',
        description: 'This is not a Rockalingua employee password',
      });
    }
  };

  return showWall ? (
    <StyledEnvironmentWall
      title={null}
      footer={null}
      closable={false}
      centered
      visible
      width="90vw"
    >
      <div className="title">Warning!</div>
      <div>
        This is a TEST environment, only Rockalingua employees can use it.
      </div>
      <div className="text-with-button">
        <span>If you are not a Rockalingua employee, please</span>
        <Button href="https://rockalingua.com" type="primary" size="large">
          Go to Rockalingua.com
        </Button>
      </div>
      <div className="text-with-button">
        <span>If you are, enter your password:</span>
        <Input.Group compact>
          <Input
            size="large"
            onPressEnter={onSubmit}
            className="input"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <Button size="large" onClick={onSubmit}>
            Continue
          </Button>
        </Input.Group>
      </div>
    </StyledEnvironmentWall>
  ) : null;
}
